import React from 'react'
import styles from './styles.module.scss'
import MostPopularInterests from './MostPopularInterests'
import OftenPairedInterests from './OftenPairedInterests'
import Interests from './Interests'
import SectionTitle from '../common/SectionTitle'
import { useTranslation } from 'react-i18next'

function InterestInsights({ type, groupType, objectId, groupName, data, interestData, loggedInUser }) {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      {groupType === 'expertise' ? (
        <SectionTitle title={t('dashboard.expertiseInsights.title')} />
      ) : (
        <SectionTitle title={t('dashboard.interestInsights.title')} />
      )}
      <div className={styles.interestInsights}>
        <div className={styles.row1}>
          <MostPopularInterests
            type={type}
            groupType={groupType}
            sectionType='popular'
            interests={data?.Most_popular_interests}
            objectId={objectId}
          />
          {type === 'group' && (
            <OftenPairedInterests
              interests={data?.Interests_paired_together}
              groupId={objectId}
              groupType={groupType}
            />
          )}
          {type === 'workplace' && (
            <MostPopularInterests
              type={type}
              sectionType='no_associated_groups'
              interests={data?.Popular_interests_with_no_associated_groups}
              objectId={objectId}
            />
          )}
        </div>
        {type === 'group' && (
          <div className={styles.row2}>
            <Interests
              type={type}
              groupType={groupType}
              data={interestData}
              groupName={groupName}
              loggedInUser={loggedInUser}
              groupId={objectId}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default InterestInsights
